<template>
  <v-snackbar
    :value="alertData.isVisible"
    @input="onSnackbarInput($event)"
    bottom
    color="error"
    :timeout="3000"
  >
    <h4 class="d-inline">{{ alertData.message }}</h4>
    <template v-slot:action>
      <v-btn class="ml-2" dark text @click="alertData.isVisible = false">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: function () {
    return {
      err: null,

      alertData: {
        message: null,
        isVisible: false,
        type: "danger",
      },
    };
  },

  computed: {
    error() {
      return this.$store.state.app.httpError;
    },
  },

  mounted() {
    this.err = this.error;

    this.processError();
  },

  watch: {
    error: function (newError, oldError) {
      console.log("got error");
      this.err = newError;

      this.processError();
    },
  },

  methods: {
    onSnackbarInput(e) {
      this.$store.commit("app/resetHttpError");
    },

    setError(error) {
      this.err = error;

      this.processError();
    },

    processError() {
      if (!this.err) {
        this.alertData.isVisible = false;

        return;
      }

      console.log("houston we have a problem...");

      console.log(this.err);

      if (this.gotError("401")) {
        // this.processExpiredSession();
        this.showAlert("Usuário ou senha invalidos");

        return;
      }

      if (this.gotError("403")) {
        if (this.err.response.data && this.err.response.data.error == "module_disabled") {          this.showAlert(this.err.response.data.message);

          return;
        }

        this.showAlert("Página bloqueada.");

        return;
      }

      if (this.gotError("419")) {
        this.processExpiredSession();

        return;
      }

      if (this.gotError("422")) {
        console.log("sound's like a 422 error...lets try understand");

        this.process422();

        return;
      }

      if (this.gotError("500")) {
        console.log("wtf, its a 500 error...");

        this.showAlert(
          "Ocorreu um erro no servidor, mas nossa equipe já está sendo alertada."
        );

        return;
      }

      if (this.gotNetworkError()) {
        this.showAlert(
          "Erro na conexão, cheque sua conexão ou tente mais tarde."
        );

        return;
      }

      this.showAlert("Algo deu errado!");
    },

    gotPlainText() {},

    gotError(errorCode) {
      if (this.err.response) {
        if (this.err.response.status) {
          return this.err.response.status == errorCode;
        }
      }

      return false;
    },

    processExpiredSession() {
      //window.location.href = "/login";
    },

    process422() {
      this.showAlert(this.extractErrorMessage());
    },

    gotNetworkError() {
      return this.err.message == "Network Error";
    },

    extractErrorMessage() {
      let errorMsg = this.err.response.data;

      console.log(errorMsg);
      console.log(this.err.message);

      if (typeof errorMsg == "object") {
        if (Object.keys(errorMsg).length == 0) {
          return "Algo deu errado!";
        }

        // seek for error object
        if (errorMsg.errors) {
          return errorMsg.errors[Object.keys(errorMsg.errors)[0]][0];
        }

        //return this.err.response.data[Object.keys(this.err.response.data)[0][0]]
      }

      if (this.err.response.data) {
        return this.err.response.data;
      }

      return "Algo deu errado!";
    },

    showAlert(msg) {
      this.alertData.message = msg;

      this.alertData.isVisible = true;
    },
  },
};
</script>

